import type {Suggestions} from '@github-ui/inline-autocomplete/types'
import {useMemo} from 'react'

import {useAvailableAgents} from '../../utils/agents-helpers'
import {AgentSuggestion} from './AgentSuggestion'

export interface AgentsQuery {
  category: 'agents'
  filter: string
}

export function useAgentsSuggestions(query: AgentsQuery | null) {
  const {availableAgents, loading} = useAvailableAgents(query !== null)

  return useMemo<Suggestions | null>(() => {
    if (!query) return null

    if (loading) return 'loading'

    return (
      availableAgents
        ?.filter(agent => query?.category === 'agents' && agent.name.toLowerCase().includes(query.filter.toLowerCase()))
        .map(agent => ({
          value: agent.slug,
          render: props => <AgentSuggestion agent={agent} {...props} />,
        })) ?? null
    )
  }, [query, availableAgents, loading])
}
